import axios from 'axios';

const apiBacen = axios.create({
    baseURL:"https://api.bcb.gov.br/dados/serie/"
})

export default apiBacen;

//Selic: //bcdata.sgs.11/dados?formato=json
//Financiamento Imobiliario: //bcdata.sgs.20704/dados?formato=json
